// Libs
import React, { useState, useMemo } from 'react';

// Own Libs

//Api
import { ICrfRelatorioCicloOrcamentario, GraficoEconomicoCicloAnualProjeto } from '@app/api/crf/crfRelatorioCicloorcamentario';

//Files
import GraficoCurva from '@app/views/GraficoCurva/index'

//Utils




interface PropGrafico {
  projetoId: string;
}

const Graficos = (props: PropGrafico) => {
  const { projetoId } = props;
  const [relatorio, setRelatorio] = useState<ICrfRelatorioCicloOrcamentario>();

  useMemo(() => {
    if (projetoId) {
      GraficoEconomicoCicloAnualProjeto(projetoId).then((data) => {
        setRelatorio(data);
      });
    }
  }, [projetoId]);

  return (
    <>
      {relatorio ? <GraficoCurva relatorio={relatorio} carregarTabela={true} /> : <> </>}
    </>
  );
};

export default Graficos;
